import { MatDialogRef } from '@angular/material/dialog';
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmBaseComponent } from './confirm-base.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-confirm-dialog',
    imports: [CommonModule, TranslateModule],
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss']
})
export class ConfirmDialogComponent extends ConfirmBaseComponent {

    constructor(
        private matDialogRef: MatDialogRef<ConfirmDialogComponent>
    ) {
        super();
        this.showCloseButton = true;
    }

    close() {
        this.matDialogRef.close();
        this.onClose.emit();
    }

    confirm() {
        this.matDialogRef.close();
        this.onConfirm.emit()
    }
}
